import React from 'react'
import { NavLink } from 'react-router-dom'
import '../styles/Navigation.css'

import obo_mne from '../lettering/obo_mne.svg'
import doodle_toys_orange from '../lettering/doodle_toys_orange.svg'
import otkritki from '../lettering/otkritki.svg'
import posteri from '../lettering/posteri.svg'
import kubiki from '../lettering/kubiki.svg'
import arhiv from '../lettering/arhiv.svg'
import gde_kupit from '../lettering/gde_kupit.svg'

const Navigation = () => {
  return (
    <div className='Navigation'>
        <NavLink className={'navLinks'} to="/about"> <img src={obo_mne} alt="Обо мне" className='about' /> </NavLink>
        <NavLink className={'navLinks'} to="/toys"> <img src={doodle_toys_orange} alt="Doodle Toys" className='toys'/> </NavLink>
        <NavLink className={'navLinks'} to="/cards"> <img src={otkritki} alt="Открытки" className='cards'/> </NavLink>
        <NavLink className={'navLinks'} to="/posters"> <img src={posteri} alt="Постеры" className='posters'/> </NavLink>
        <NavLink className={'navLinks'} to="/cubes"> <img src={kubiki} alt="Кубики и магниты" className='cubes'/> </NavLink>
        <NavLink className={'navLinks'} to="/archive"> <img src={arhiv} alt="Архив" className='archive'/> </NavLink>
        <NavLink className={'navLinks'} to="/buy"> <img src={gde_kupit} alt="Где купить" className='buy'/> </NavLink> 
    </div>
  )
}

export default Navigation